import { Component, inject, Input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MaterialModule } from '../../shared/material.module';
import { ConfirmationDialogService } from '../../services/confirmation-dialog.service';
import { AboutDialogService } from '../../services/about-dialog.service';
import { CurrentUserState } from '../../state/current-user.state';
import { UserSessionTrackerService } from '../../services/user-session-tracker.service';
import { AuthSyncService } from '../../services/auth-sync.service';
import { AppUserRole } from '../../models/enums/appUserRole.enum';

@Component({
  selector: 'app-profile-menu',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    MatIconModule,
    MatDividerModule],
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss']
})
export class ProfileMenuComponent {
  private readonly authSync = inject(AuthSyncService);
  private readonly currentUserState = inject(CurrentUserState);
  private readonly sessionTracker = inject(UserSessionTrackerService);
  private readonly aboutDialog = inject(AboutDialogService);

  @Input() hideMessages = false;

  // Computed properties from current user data
  fullName = computed(() => this.currentUserState.user()?.fullName || 'User');
  email = computed(() => this.currentUserState.user()?.email || '');
  role = computed(() => {
    const userRole = this.currentUserState.user()?.role;
    switch (userRole) {
      case AppUserRole.Admin:
        return 'Administrator';
      case AppUserRole.Leader:
        return 'Leader';
      case AppUserRole.User:
        return 'User';
      case AppUserRole.Customer:
        return 'Customer';
      default:
        return 'User';
    }
  });

  constructor(
    private confirmationDialogService: ConfirmationDialogService,
    private router: Router
  ) {}

  public goToMessages(): void {
    this.router.navigate(['/messages']);
  }

  public changePassword(): void {
    const isCustomer = this.currentUserState.user()?.role === AppUserRole.Customer;
    this.router.navigate([isCustomer ? '/portal/change-password' : '/change-password']);
  }

  public openAbout(): void {
    this.aboutDialog.open();
  }

  public logout() {
    this.confirmationDialogService.openLogoutConfirmationDialog()
    .subscribe(result => {
      if (result) {
        this.sessionTracker.endCurrentSession();
        this.authSync.logout();
      }
    });
  }
}
